// Production URLs
export let assetsUrl = "https://labelling.api.dev.oncoustics.com";
export let baseUrl = "https://labelling.api.dev.oncoustics.com/api";

if (process.env.REACT_APP_API === "local") {
  assetsUrl = "http://localhost:4000/api";
  baseUrl = "http://localhost:4000/api";
}
